import { Pipe, PipeTransform } from '@angular/core';
import { OrderStatus } from '@zero/shared/util-models';

@Pipe({
  name: 'snackbarHasOrderStatus',
  standalone: true,
})
export class SnackbarHasOrderStatusPipe implements PipeTransform {
  public transform = (value: OrderStatus, arg: string): boolean => value.toString().includes(arg);
}
